import { FC, useEffect, useRef, useState } from 'react'
import SwiperType from 'swiper'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'

import { useDataContext } from 'context/data-context'
import { VideoTile } from './video-tile'
import { Backdrop, Container, NavButton } from './styled'

type Props = {
  activeEpisodeIndex: number
  onClose: () => void
}

export const VideoPlayer: FC<Props> = ({ activeEpisodeIndex, onClose }) => {
  const { episodes } = useDataContext()
  const [currentSlide, setCurrentSlide] = useState(activeEpisodeIndex)
  const swiper = useRef<SwiperType>()
  const prevButton = useRef<HTMLButtonElement>(null)
  const nextButton = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    document.body.classList.add('locked')

    return () => {
      document.body.classList.remove('locked')
    }
  })

  return (
    <Container>
      <Backdrop onClick={onClose} />
      <Swiper
        centeredSlides
        slidesPerView="auto"
        initialSlide={activeEpisodeIndex}
        modules={[Navigation]}
        onSlideChange={() => {
          if (swiper.current) {
            setCurrentSlide(swiper.current.activeIndex)
          }
        }}
        onInit={s => {
          swiper.current = s
        }}
      >
        {episodes.map((episode, index) => (
          <SwiperSlide key={episode.episode_title}>
            <VideoTile episode={episode} isActive={index === currentSlide} />
          </SwiperSlide>
        ))}
      </Swiper>

      <NavButton
        ref={prevButton}
        disabled={currentSlide <= 0}
        onClick={() => {
          swiper.current?.slidePrev()
        }}
      />
      <NavButton
        ref={nextButton}
        onClick={() => {
          swiper.current?.slideNext()
        }}
        disabled={currentSlide >= episodes.length - 1}
        data-right
      />
    </Container>
  )
}
